import { AddCrmModalStep } from "@/features/crm_system/lib/_core/crmSystem";
import { CrmNameAndSystemStep, CrmNameAndSystemStepTitle } from "../components/organisms/CrmNameAndSystemStep";
import { ProjectSelectionStep, ProjectSelectionStepTitle } from "../components/organisms/ProjectSelectionStep";

export const predefinedStepsSimplified: AddCrmModalStep[] = [
    // {
    //     stepTitle: ProjectSelectionStepTitle,
    //     stepComponent: ProjectSelectionStep
    // },
    {
        stepTitle: CrmNameAndSystemStepTitle,
        stepComponent: CrmNameAndSystemStep
    }
]